import { X } from "lucide-react";
import type React from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface BasicModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  maxWidth?: string;
  maxHeight?: string;
  showCloseButton?: boolean;
}

export const BasicModal: React.FC<BasicModalProps> = ({
  isOpen,
  onClose,
  children,
  title = "Dialog",
  maxWidth = "max-w-lg",
  maxHeight,
  showCloseButton = true,
}) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        hideCloseButton
        overlayClassName="z-[var(--z-basic-modal-overlay)] border border-black/50 bg-black/40 backdrop-blur-sm"
        className={cn(
          "z-[var(--z-basic-modal-content)] flex max-h-[90vh] w-full flex-col gap-0 overflow-hidden rounded-tr-xl border-0 bg-white p-0 shadow-none",
          maxWidth,
          maxHeight,
        )}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>

        {showCloseButton && (
          <Button
            onClick={onClose}
            variant="ghost"
            className="absolute right-4 top-4 z-20 bg-white/70 backdrop-blur-sm hover:bg-white"
          >
            <X className="size-5" />
          </Button>
        )}

        <div className="flex-1 overflow-auto">{children}</div>
      </DialogContent>
    </Dialog>
  );
};
